// getters.js

export default {
    getMenuTree(state){
        return state.menuTree
    }
};
